import React from "react"
import PropTypes from "prop-types"
import Container from "react-bootstrap/Container"

import Header from "../layout/header"
import Footer from "../layout/footer"
import "./layout.scss"

const Layout = ({ children }) => {
  return (
    <>
      <header className="site-header">
        <Container>
          <Header />
        </Container>
      </header>

      <main className="site-content">
        <Container>{children}</Container>
      </main>

      <footer className="site-footer">
        <Container>
          <Footer />

          <div className="copyright">
            © {new Date().getFullYear()} Carl Hanser Verlag GmbH & Co. KG
          </div>
        </Container>
      </footer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
